import TaxiCorporationOrderBillingsDownloadResponse from "../../../../api/raily/taxi-corporation/order-billings/download/taxi-corporation-order-billings-download.response";
import TaxiCorporationOrderBillingsDownload from "./taxi-corporation-order-billings-download";

const create = (
  response: TaxiCorporationOrderBillingsDownloadResponse,
): TaxiCorporationOrderBillingsDownload => {
  const data = response.data;

  return {
    data: data.data,
    filename: data.filename,
  };
};

const taxiCorporationOrderBillingsDownloadFactory = {
  create,
};

export default taxiCorporationOrderBillingsDownloadFactory;
